import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeaderMenu from "./sidebar/headermenu";
import PostWrap from "./posts/post_wrap";
import RightWrap from "./rightside/right_wrap";
import { API_STATUS } from "../constants";
import Story from "./story";

export default function PostHome() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const globalState = useSelector(state => state.globalstate);

    const [userApi, setUserApi] = useState(API_STATUS);
    const [activeUser, setActiveUser] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        }
    }, []);

    const ulogout = () => {
        sessionStorage.removeItem('LOGIN_TOKEN');

        localStorage.removeItem('LOGIN_TOKEN');
        localStorage.removeItem('LOGIN_DATA');
        navigate('/login');
    }

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="main__inner">
                <div className="flex max-lg:flex-col xl:gap-10 md:gap-3 md:mt-10" id="js-oversized">
                    <PostWrap />
                    <RightWrap />
                </div>
            </div>
        </main>
    </div>

}